<template>
    <div>
        <CommunicationsTable
            :communications="props.communications"
            :filters="props.filters"
            :types="props.types"
            @changePage="changePage"
            @resetFilters="resetFilters"
        />
    </div>
</template>

<script setup>

import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import CommunicationsTable from '~@/Components/Tools/Communications/CommunicationTable'

const props = defineProps({
    communications: {
        type: Object,
        default: () => {
            return {}
        }
    },
    filters: {
        type: Object,
        default: () => {
            return {}
        }
    },
    types: {
        type: Array,
        default: () => {
            return []
        }
    }
})

function changePage (page, filters) {
    const queryParameters = Object.fromEntries(Object.entries(filters).filter(([_, v]) => v))

    if (page !== 1) {
        queryParameters.page = page
    }

    router.get(route('tools.communications.index', {
        save_filters: true
    }), queryParameters)
}
function resetFilters () {
    router.get(route('tools.communications.index', {
        save_filters: true, default_filters: true
    }))
}

</script>
